import { useRequest } from "../../../hooks/useRequest";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import routes from "../../../routes";

function useSendInviteEmail(userId: string) {
  const { fetch, response, error, loading } = useRequest();

  const { alert, setAlert } = useHttpResponseAlert(
    error,
    response,
    "Invite email was successfully sent!",
  );

  const send = () => {
    fetch("PUT", routes.api.user.invite({ userId }));
  };

  return {
    send,
    loading,
    isSent: response?.status === 200,
    alert,
    setAlert,
  };
}

export default useSendInviteEmail;
